<template>
    <div>
        <!-- 轮播图 -->
        <banner
            :carousel="homeConfig.carousel"
            v-if="homeConfig.carousel.length > 0"
        />
        <!-- 产品系列 -->
        <product
            :instrumentCategory="homeConfig.instrumentCategory"
            :productCategory="productCategory"
            v-if="productCategory.length"
        />
        <!-- 关于DeepWave -->
        <about />

        <!-- 新产品 -->
        <!-- <product-new
            :newProduct="homeConfig.newProduct"
            :sysProduct="sysProduct"
            v-if="sysProduct.length"
        /> -->
        <!-- 主要产品 -->
        <!-- <product-main :mainProduct="homeConfig.mainProduct" :sysProduct="sysProduct" /> -->
        <!-- 解决方案 -->
        <solution />
        <!-- 适用领域 -->
        <!-- <contact /> -->
        <!-- 合作伙伴 -->
        <!-- <cooperative-partner /> -->
    </div>
</template>

<script>
import {
    sysHomeConfig,
    getsysProduct,
    getProductCategory,
    sysCompanyInfo,
} from "@/api/index";
export default {
    components: {
        banner: () => import("./components/banner.vue"),
        about: () => import("./components/about.vue"),
        product: () => import("./components/product.vue"),
        ProductNew: () => import("./components/product-new.vue"),
        ProductMain: () => import("./components/product-main.vue"),
        solution: () => import("./components/solution.vue"),
        contact: () => import("./components/contact.vue"),
        CooperativePartner: () =>
            import("./components/cooperative-partner.vue"),
    },
    data() {
        return {
            homeConfig: {
                id: "",
                carousel: [{ imgUrl: "", link: "" }],
                instrumentCategory: [], //产品分类
                newProduct: "", //新产品
                mainProduct: [], //主要产品
                hotProduct: [], //热门产品
            },
            productCategory: [],
            sysProduct: [],
            companyInfo: {},
        };
    },
    async mounted() {
        await this.fetchData();
        await this.getProductCategory();
        await this.getsysProduct();
        // await this.sysCompanyInfo();
    },
    methods: {
        // 获取首页配置信息
        async fetchData() {
            try {
                const res = await sysHomeConfig({ current:1,size:500 });
                const data = res.data.records || [];
                if (data && data.length) {
                    const form = data[0];
                    Object.assign(this.homeConfig, {
                        ...form,
                        carousel: JSON.parse(form.carousel), //轮播图
                        hotProduct: form.hotProduct.split(","), //热门产品
                        mainProduct: form.mainProduct.split(","), //主要产品
                        instrumentCategory: form.instrumentCategory.split(","), //产品分类
                    });
                }
            } catch (error) {
                console.error("获取数据失败", error);
            } finally {
                // this.loading = false;
            }
        },
        // 获取产品分类列表
        async getProductCategory() {
            try {
                const res = await getProductCategory({ current:1,size:500 });
                this.productCategory = res.data.records || [];
            } catch (error) {
                console.error("获取数据失败", error);
            } finally {
            }
        },
        // 获取产品列表
        async getsysProduct() {
            try {
                const res = await getsysProduct({ current:1,size:500 });
                this.sysProduct = res.data.records || [];
            } catch (error) {
                console.error("获取数据失败", error);
            } finally {
            }
        },
        async sysCompanyInfo() {
            try {
                const res = await sysCompanyInfo({ current:1,size:500 });
                const data = res.data.records || [];
                this.companyInfo = data[0];
            } catch (error) {
                console.error("获取数据失败", error);
            } finally {
            }
        },
    },
};
</script>

